export default "__VITE_ASSET__0ce4aaf8__"